module.exports = __webpack_public_path__ + "static/media/humidityForecast.29d6f2fa.png";